import React, { FC, useEffect } from "react";
import styles from "./Time.module.scss";
import VetIcon from "./../../../../Static/Images/Time_QueroVet.png";
import { IVeterinarioContext } from "../../../../Context/Veterinario/Interfaces/IVeterinarioContext";
import { IResponse } from "../../../../Data/Interfaces/Base/IResponse";
import { IVeterinario } from "../../../../Data/Interfaces/Request/Veterinario/IVeterinario";
import { isMobile } from "react-device-detect";

interface ITime {
  vetContext: IVeterinarioContext;
}

export const Time: FC<ITime> = ({ vetContext }) => {
  useEffect(() => {
    vetContext.effects && vetContext.effects.getAllVeterinarios();
  }, []);

  return (
    <div className={`${styles["Time"]}  ${isMobile ? styles["mobile"] : ""}`}>
      <span className={styles["Title"]}>Time QueroVet</span>
      <span className={styles["SubTitle"]}>
        A QueroVet conta com os melhores médicos veterinários, sempre a sua
        disposição e <br /> preparados para atender seu pet diretamente na sua
        casa!
      </span>
      <div className={styles["Vets"]}>
        {(vetContext.result as IResponse<IVeterinario[]>).data.map(
          (item, idx) => {
            return (
              <div key={`vet-${idx}`} className={styles["Vet"]}>
                <img
                  alt="Vet 01"
                  className={item.avatar ? styles["avatar"] : ""}
                  src={item.avatar ? item.avatar : VetIcon}
                />
                <span>{item.nome}</span>
              </div>
            );
          }
        )}
      </div>
    </div>
  );
};
